/**
 * Invoice Template Designer Route for New Templates
 */

import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { FeatureGate } from '@/components/ui/feature-gate'

export const Route = createFileRoute(
  '/(app)/dashboard/invoice-template/designer/new',
)({
  component: NewDesignerRedirect,
})

function NewDesignerRedirect() {
  useEffect(() => {
    window.location.href = '/invoice-template?id=new'
  }, [])
  
  return (
    <FeatureGate featureId="template-designer">
      <div>Wird geladen...</div>
    </FeatureGate>
  )
}
